import * as React from 'react';
import { BookShop as BookShopType } from '../../../../../../types/Book';
import './BookShop.css';

interface Props {
	shop: BookShopType[];
}

const BookShop: React.FC<Props> = ({ shop }) => {
	return (
		<div className="bookShop">
			<div className="bookShop-header">Наличие в магазинах:</div>

			{shop.map((item) => {
				return (
					<div className="bookShop-item">
						<img className="bookShop-item__img" src={item.icon} />

						<div className="bookShop-item__name">{item.name}</div>

						<a href={item.url} target="_blank">
							Перейти
						</a>
					</div>
				);
			})}
		</div>
	);
};

export default BookShop;
